// eslint-disable-next-line no-unused-vars
export const research = [
  {
    id: 1,
    title: "Using ARIMA and LSTM to Implement Stock Market Analysis",
    authors: "Avinash Pandey, Mir Junaid Rasool",
    venue: "2023 International Conference on Artificial Intelligence and Smart Communication (AISC)",
    year: "2023",
    tags: ["Scopus", "IEEE", "Conference"],
    doi: "https://doi.org/10.1109/aisc56616.2023.10085405",
    paper: "https://www.researchgate.net/publication/369775794_Using_ARIMA_and_LSTM_to_Implement_Stock_Market_Analysis",
    linklive: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=xcKjNJ0AAAAJ&citation_for_view=xcKjNJ0AAAAJ:zYLM7Y9cAGgC"
  },
  {
    id: 2,
    title: "Risk prediction of breast cancer from real time streaming health data using machine learning",
    authors: "MJ Rasool, AS Brar, HS Kang",
    venue: "International Research Journal of Modernization in Engineering Technology and Science",
    year: "2020",
    tags: ["Journal"],
    doi: "https://doi.org/10.5281/zenodo.4284315",
    paper: "https://www.researchgate.net/profile/Mir-Junaid-Rasool/publication/346091677_RISK_PREDICTION_OF_BREAST_CANCER_FROM_REAL_TIME_STREAMING_HEALTH_DATA_USING_MACHINE_LEARNING/links/5fbb8c1c299bf104cf6d3ae1/RISK-PREDICTION-OF-BREAST-CANCER-FROM-REAL-TIME-STREAMING-HEALTH-DATA-USING-MACHINE-LEARNING.pdf",
    linklive: "https://scholar.google.com/citations?view_op=list_works&hl=en&user=xcKjNJ0AAAAJ"
  },
  {
    id: 3,
    title: "Spark based Health Status Prediction on Real Time Streaming Data using Machine Learning",
    authors: "MJ Rasool, AS Brar, HS Kang",
    venue: "International Journal for Research in Applied Science & Engineering Technology (IJRASET)",
    year: "2020",
    tags: ["Journal"],
    doi: "https://doi.org/10.22214/ijraset.2020.32197",
    paper: "https://www.researchgate.net/profile/Mir-Junaid-Rasool/publication/346090938_Spark_based_Health_Status_Prediction_on_Real_Time_Streaming_Data_using_Machine_Learning/links/5fbb4056299bf104cf6cf228/Spark-based-Health-Status-Prediction-on-Real-Time-Streaming-Data-using-Machine-Learning.pdf",
    linklive: "https://scholar.google.com/citations?view_op=list_works&hl=en&user=xcKjNJ0AAAAJ"
  },
  {
    id: 4,
    title: "Machine Learning on Healthcare Big Data Using Apache Spark",
    authors: "MJ Rasool, AS Brar, HS Kang",
    venue: "Book chapter: Applications of AI and Machine Learning (ISBN: 978-81941048-7-2)",
    year: "2020",
    tags: ["Book Chapter", "Conference"],
    paper: "https://www.researchgate.net/profile/Mir-Junaid-Rasool/publication/359195614_Machine_Learning_on_Healthcare_Big_Data_Using_Apache_Spark/links/622cda1d97401151d213fcc4/Machine-Learning-on-Healthcare-Big-Data-Using-Apache-Spark.pdf",
    linklive: "https://scholar.google.com/citations?view_op=list_works&hl=en&user=xcKjNJ0AAAAJ"
  },
  {
    id: 5,
    title: "Flutter and Firebase making Cross-Platform Application Development Hassle-Free",
    authors: "J Singh, S Srivastva, D Raj, S Singh, MJ Rasool",
    venue: "International Research Journal of Modernization in Engineering Technology and Science",
    year: "2022",
    tags: ["Journal"],
    paper: "",
    linklive: "https://scholar.google.com/citations?user=xcKjNJ0AAAAJ"
  },
  {
    id: 6,
    title: "A COMPARISON OF ML ALGORITHMS FOR PREDICTING BREAST CANCER RISK USING HEALTH DATA",
    authors: "VM Surbhi, Aarti, Mir Junaid Rasool",
    venue: "Computer Science & Engineering: An International Journal (CSEIJ)",
    year: "2025",
    tags: ["Journal"],
    paper: "",
    linklive: "https://scholar.google.com/citations?user=xcKjNJ0AAAAJ"
  },
  {
    id: 7,
    title: "Optical Character Recognition using Support Vector Machine",
    authors: "MJ Rasool, R Sharma, PS Tanwar",
    venue: "Intelligent Circuits and Systems for SDG 3–Good Health and Well-being, pp. 58–65",
    year: "2024",
    tags: ["Conference"],
    paper: "",
    linklive: "https://scholar.google.com/citations?user=xcKjNJ0AAAAJ"
  },
  {
    id: 8,
    title: "A Systematic Review of Social Media Mining: Twitter Sentiments Comparison",
    authors: "R Sharma, M Junaid Rasool, K Arora",
    venue: "Proceedings of the KILBY 100 7th International Conference on Computing Sciences",
    year: "2023",
    tags: ["Conference"],
    paper: "",
    linklive: "https://scholar.google.com/citations?user=xcKjNJ0AAAAJ"
  },
  {
    id: 9,
    title: "Blockchain Voting Application",
    authors: "A Chanda, M Junaid Rasool",
    venue: "Proceedings of the KILBY 100 7th International Conference on Computing Sciences",
    year: "2023",
    tags: ["Conference"],
    paper: "",
    linklive: "https://scholar.google.com/citations?user=xcKjNJ0AAAAJ"
  },
  {
    id: 10,
    title: "A Machine Learning Based Model Designed to Smartphone Addiction",
    authors: "D Ganesh Kumar, A Sathvik Dev, M Junaid Rasool",
    venue: "A Machine Learning Based Model Designed to Smartphone Addiction (May 5, 2023)",
    year: "2023",
    tags: ["Conference"],
    paper: "",
    linklive: "https://scholar.google.com/citations?user=xcKjNJ0AAAAJ"
  },
  {
    id: 11,
    title: "A Comprehensive Review of Machine Learning Applications in Wastewater Treatment: Current State, Comparative Analysis, and Future Directions",
    authors: "Mir Junaid Rasool and J. Somashekar",
    venue: "Indonesia Nov 2025",
    year: "2025",
    tags: ["Journal"],
    paper: "http://eprints.intimal.edu.my/2240/",
    linklive: "https://scholar.google.com/citations?user=xcKjNJ0AAAAJ"
  }
];
